import { StateStorage } from 'zustand/middleware'
import { createStore } from '../../state'

export interface BackupSeedStore {
  shouldBackupSeed: boolean
  setShouldBackupSeed: (shouldBackupSeed: boolean) => void
}

export const createBackupSeedStore = (storage: StateStorage) =>
  createStore<BackupSeedStore>(
    storage,
    (set) => ({
      shouldBackupSeed: false,
      setShouldBackupSeed: (shouldBackupSeed: boolean) => {
        set({ shouldBackupSeed })
      },
    }),
    {
      persist: {
        name: 'backupSeed',
        version: 0,
      },
    }
  )
